package com.arena_web.ui.components.widgets

import androidx.compose.runtime.*
import com.arena_web.ui.components.buttons.PrimaryButton
import com.arena_web.ui.components.buttons.SecondaryButton
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.utils.*
import com.arena_web.utils.Analytics
import com.arena_web.utils.Storage
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

private const val COOKIE_CONSENT_KEY = "cookie_consent"

val CookieSlideUpKeyframes = Keyframes {
    from {
        Modifier.translateY(100.percent).opacity(0)
    }
    to {
        Modifier.translateY(0.percent).opacity(1)
    }
}

@Composable
fun CookieConsent(
    modifier: Modifier = Modifier
) {
    var isVisible by remember { mutableStateOf(!Storage.contains(COOKIE_CONSENT_KEY)) }

    // Returning visitor who accepted earlier — load analytics right away.
    LaunchedEffect(Unit) { Analytics.initIfConsented() }

    if (!isVisible) return

    val t = LocalAppStrings.current
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Box(
        modifier = modifier
            .position(Position.Fixed)
            .bottom(0.px)
            .left(0.px)
            .right(0.px)
            .zIndex(999)
            .sPadding(16)
            .animation(
                CookieSlideUpKeyframes.toAnimation(
                    duration = Constants.ANIMATION_NORMAL.ms,
                    timingFunction = AnimationTimingFunction.EaseOut
                )
            ),
        contentAlignment = Alignment.BottomCenter
    ) {
        Box(
            modifier = Modifier
                .sMaxWidth(900)
                .fillMaxWidth()
                .backgroundColor(colors.surface)
                .sBorderRadius(12)
                .sPadding(20, 24)
                .styleModifier {
                    property("box-shadow", "0 -4px 24px rgba(0, 0, 0, 0.2)")
                    property("border", "1px solid ${colors.border}")
                }
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().sGap(16),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column(
                    modifier = Modifier.fillMaxWidth().sGap(4),
                ) {
                    SpanText(
                        t.widgetCookieTitle,
                        modifier = Modifier
                            .sFontSize(16)
                            .color(colors.textPrimary)
                    )
                    SpanText(
                        t.widgetCookieMessage,
                        modifier = Modifier
                            .sFontSize(14)
                            .color(colors.textSecondary)
                    )
                }

                Row(
                    modifier = Modifier.sGap(8),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SecondaryButton(
                        text = t.widgetCookieDecline,
                        onClick = {
                            Storage.save(COOKIE_CONSENT_KEY, "declined")
                            isVisible = false
                        },
                        size = ButtonSize.MD
                    )
                    PrimaryButton(
                        text = t.widgetCookieAccept,
                        onClick = {
                            Storage.save(COOKIE_CONSENT_KEY, "accepted")
                            Analytics.onConsentGranted()
                            isVisible = false
                        },
                        size = ButtonSize.MD
                    )
                }
            }
        }
    }
}
